export function About() {
  return (
    <section id="about">
      <div className="container">
        <div className="about-grid">
          <div>
            <div className="about-photo-wrap">
              <img
                src="/assets/about/tuur.jpg"
                alt="Tuur Van holen, oprichter Makers Hub"
                className="about-photo"
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "https://placehold.co/400x400/2563EB/ffffff?text=TUUR";
                }}
              />
              <span className="about-badge">Oprichter</span>
            </div>
          </div>
          <div className="about-text">
            <span className="section-tag">Wie ben ik?</span>
            <h2>
              Plek waar ik zelf naar <span className="accent">zocht</span>.
            </h2>
            <p>
              Ik was al jong verkocht aan elektronica. Kapotte laptops openschroeven, LEDjes
              laten branden, eerste regeltjes code. Allemaal op mijn zolderkamer, met YouTube
              als leraar. In mijn buurt was er niks. Geen club, geen workshop, nergens waar je
              kon binnenvallen met "hé, ik heb een idee".
            </p>
            <p>
              Vandaag bouw ik software en AI voor bedrijven. In mijn vrije tijd prutsen met 3D
              prints, Arduino en sensoren. De helft werkt niet meteen. Net dat maakt het leuk.
              Dat gevoel van proberen, falen en opnieuw beginnen wil ik doorgeven aan
              kinderen.
            </p>
            <blockquote className="about-quote">
              "Makers Hub is gewoon de plek die ik zelf gemist heb. Klein, betaalbaar, hands
              on, met mensen die meedenken als je vastloopt."
            </blockquote>
            <p>
              Daarom start ik <strong>Makers Hub</strong>. Kinderen vanaf 10 jaar leren op
              zaterdag niet alleen programmeren, ze nemen ook iets mee naar huis waar ze trots
              op zijn. We zijn net begonnen, in kleine groepjes, samen met gezinnen die mee
              willen bouwen.
            </p>
            <p>
              Later komt er ook een open werkplaats voor volwassenen die graag zelf blijven
              knutselen. Voor nu volle focus op de kids.
            </p>
            <p>
              Ouder van een nieuwsgierig kind? Of zelf graag dingen maken? Kom eens langs.
              Geen drempel, geen stress, gewoon beginnen.
            </p>
            <div className="about-signature">
              <div>
                <strong>Tuur Van holen</strong>
                <span>Oprichter · Makers Hub</span>
              </div>
              <div className="about-social">
                <a
                  href="https://www.linkedin.com/in/tuurvanholen/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Tuur Vanholen op LinkedIn"
                  title="LinkedIn"
                >
                  <span aria-hidden="true">in</span>
                </a>
                <a
                  href="mailto:hallo.contact@makershub.be"
                  aria-label="Mail Tuur Vanholen"
                  title="Email"
                >
                  <span aria-hidden="true">@</span>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61570829679229"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Makers Hub op Facebook"
                  title="Facebook"
                >
                  <span aria-hidden="true">FB</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
